import React from 'react'
import styled from "@emotion/styled";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import no_image from '../assets/images/no_image.png'
import koyala from '../assets/images/koyala.jfif'
import { CardHeader } from '@mui/material';

const getMuiTheme = () => createTheme({
    components: {
        MuiCardHeader:{
            styleOverrides:{
                root:{
                    padding:'5px 0px'
                }
            }
        },
        MuiCard:{
            styleOverrides:{
                root:{
                    boxShadow:'none',
                    border:'1px solid #ccc ' //#c9e8fa
                }
            }
        },
        MuiCardContent:{
            styleOverrides:{
                root: {
                    padding:'10px',
                    height:'135px'
                }
            }
        },
        MuiCardActions: {
            styleOverrides:{
                root: {
                    padding:'5px 0px 0px 5px'
                }
            }
        }
    }
})

const StyledCard = styled(Card)({
    padding:'5px',
    backgroundColor: '#FFF',
    "&:hover": {
        backgroundColor : "#def1fc" ,
        cursor:'grab'
    }
  });

function CustomCard({
    headTitle='Head Title',
    headerTitle='Education',
    title='', 
    description='Description',
    buttonTitle='Learn more',
    image=koyala,
    handleCardClick=()=>{},
}) {


  return (
    <div>
    <ThemeProvider theme={getMuiTheme()}>
        <StyledCard sx={{ maxWidth: 350, margin:'10px' }} onClick={handleCardClick}>
        <CardHeader  title={headTitle} />
          <CardMedia
            sx={{ height: 220 }}
            image={image}
            title="green iguana"
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
             {description}
            </Typography>
          </CardContent>
        </StyledCard>
    </ThemeProvider>
        </div>
  )
}

export default CustomCard